import styled from 'styled-components/macro'

// export const  = styled.input`
//     height: 1em;
//     width: 1em;
//     :disabled {
//         opacity: 1;
//     }
// `

export const Item = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  position: relative;
  box-sizing: border-box;
  border-radius: 2px;
`

export const RadioButtonLabel = styled.label`
  position: absolute;
  top: 33%;
  left: 4px;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  background: white;
  border: 1px solid #ccc;
`

export const StyledRadio = styled.input`
  opacity: 0;
  z-index: 1;
  cursor: pointer;
  width: 25px;
  height: 25px;
  // margin-right: 10px;
  &:hover ~ ${RadioButtonLabel} {
    background: #f6d318;
    &::after {
      display: block;
      color: white;
      width: 12px;
      height: 12px;
      margin: 4px;
    }
  }
  &:checked + ${Item} {
    background: #f6d318;
    border: 2px solid #ccc;
  }
  &:checked + ${RadioButtonLabel} {
    background: #f6d318;
    border: 1px solid #ccc;
    &::after {
      display: block;
      color: white;
      width: 12px;
      height: 12px;
      margin: 4px;
    }
  }
`
